export const BASE_API_URL         = process.env.REACT_APP_API_URL
export const OIDC_AUTH_SERVER_URL = process.env.REACT_APP_OIDC_AUTH_SERVER_URL
export const OIDC_CLIENT_ID       = process.env.REACT_APP_OIDC_CLIENT_ID